import { SET_TABLE_PROCESS } from './action';

const initialState = {
  delete: {},
  copy: {},
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
  case SET_TABLE_PROCESS:
    return {
      ...state,
      [payload.processType]: {
        ...state[payload.processType],
        [payload.entityType]: payload.ids,
      },
    };
  default:
    return state;
  }
};
